import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DropdownOptions } from "../../components/common/Dropdown/Dropdown";
import { AccountType } from "../../types/genericType";


type clientDetails = {
  clientDetails: Array<DropdownOptions>;
  accountDetails: Array<AccountType>;
};

const initialState: clientDetails = {
  clientDetails: [],
  accountDetails: [],
};

export const clientDetailsSlice = createSlice({
  name: "clientDetails",
  initialState,
  reducers: {
    setClientDetails: (state, action: PayloadAction<Array<DropdownOptions>>) => {
      state.clientDetails = action.payload;
    },
    setAccountDetails: (state, action: PayloadAction<Array<AccountType>>) => {
      state.accountDetails = action.payload;
    },
  },
});

export const { setClientDetails, setAccountDetails } =
  clientDetailsSlice.actions;

export default clientDetailsSlice.reducer;
